window.dataLayer = window.dataLayer || [];

export function pushDL(eventName, payload) {
  const data = Object.assign({ event: eventName }, payload || {});
  window.dataLayer.push(data);
  if (window.DL_DEBUG) console.log('[dataLayer]', data);
}

export function produtoItemId(id) {
  return `MT_PROD_${id}`;
}

export function listaProdutosId(nome) {
  const slug = (nome || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, '');
  return 'matinal_products_' + (slug || 'all');
}

export function pushEcommerceDL(eventName, ecommerce) {
  window.dataLayer.push({ ecommerce: null });
  pushDL(eventName, { ecommerce: Object.assign({ currency: 'EUR' }, ecommerce) });
}
